import { Agents } from "@/queries/agent-queries";

type AgentOption = {
    id: string | null;
    label: string;
};

const AGENT_OPTIONS: AgentOption[] = [
    { id: null, label: "Ona" },
    { id: Agents.InEnvironmentClaudeCode.id, label: "Claude Code" },
    { id: Agents.InEnvironmentCodex.id, label: "Codex" },
    { id: Agents.InEnvironmentGemini.id, label: "Gemini" },
    { id: Agents.InEnvironmentClaudeAgent.id, label: "Claude Agent" },
];

/** Maps an agent ID to its display name. */
export function getAgentDisplayName(agentId?: string): string {
    if (!agentId) {
        return "Ona";
    }
    const option = AGENT_OPTIONS.find((o) => o.id === agentId);
    return option?.label ?? "Ona";
}
